'use strict';

var cell = require('../../../../../../../../../../_virtual/cell.cjs');
require('../../base/accentColors.cjs');
var accentColors = require('../../../../../../../../../../_virtual/accentColors.cjs');

(function (exports) {

	var accentColors$1 = accentColors.__exports;

	exports.CELL_BASE_COLORS = void 0;
	(function(CELL_BASE_COLORS) {
	    CELL_BASE_COLORS["system"] = "system";
	    CELL_BASE_COLORS["highlight"] = "highlight";
	})(exports.CELL_BASE_COLORS || (exports.CELL_BASE_COLORS = {}));
	const CELL_COLORS = {
	    ...exports.CELL_BASE_COLORS,
	    ...accentColors$1.AVIARY_ACCENTS
	};

	exports.CELL_COLORS = CELL_COLORS;
	
} (cell.__exports));
//# sourceMappingURL=cell.cjs.map
